<!-- 表格自适应高度 -->
<template>
  <div class="table-wrap">
    <div class="table">
      <slot name="table"></slot>
    </div>
    <slot name="pagination"></slot>
  </div>
</template>

<script>
export default {
  name: 'tableWrap',
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
.table-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  .table {
    flex: 1;
  }
}
</style>